import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { BenefitsSection } from '../components/sales/BenefitsSection';
import { WhatYouGetSection } from '../components/sales/WhatYouGetSection';
import { CTASection } from '../components/sales/CTASection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#fdfbf7] font-body text-gray-900" data-id="element-214">
      <main data-id="element-215">
        <HeroSection data-id="element-216" />
        <ProblemSection data-id="element-217" />
        <SolutionSection data-id="element-218" />
        <BenefitsSection data-id="element-219" />
        <WhatYouGetSection data-id="element-220" />
        <CTASection data-id="element-221" />
      </main>
      <Footer data-id="element-222" />
    </div>;
}